// extracted by mini-css-extract-plugin
export var bodyRow = "_j4-d";
export var cardColumns = "_j4-e";
export var ellipsesOverflow = "_j4-2";
export var flatBottomCorners = "_j4-3";
export var flatTopCorners = "_j4-4";
export var headerActionsDropdown = "_j4-f";
export var headerBottomRow = "_j4-c";
export var headerTopRow = "_j4-b";
export var orderDetailsWrapper = "_j4-0";
export var orderInfoContainer = "_j4-1";
export var productDetails = "_j4-9";
export var productImage = "_j4-5";
export var responsiveTable = "_j4-8";
export var shipmentContainer = "_j4-a";
export var tableBottomLeft = "_j4-6";
export var tableBottomRight = "_j4-7";